import type { SelectionExtensionPluginOptions } from '@atlaskit/editor-plugin-selection-extension';

import { useJiraWorkCreateSelectionExtension } from '@confluence/jira-work-create-extension';
import { fg } from '@confluence/feature-gating';

export const useSelectionExtensionPluginOptions = (): SelectionExtensionPluginOptions => {
	const jiraWorkCreateSelectionExtension = useJiraWorkCreateSelectionExtension();

	return {
		extensions: {
			firstParty: [
				...(fg('confluence_work_create_edit_and_live_docs_support')
					? [jiraWorkCreateSelectionExtension]
					: []),
			],
		},
	};
};
